<template>
  <div class="rounded-none lg:rounded-lg bg-white pb-6">
    <v-lazy-image
      :src="getFirstUrl(warehouse.photos)"
      src-placeholder="/img/WareX-chicklet.png"
      class="warehouse-photo rounded-none lg:rounded rounded-b-none"
    />
    <div class="info mt-6 px-3">
      <h2 class="text-xl leading-tight mb-2 hidden md:block">
        <nuxt-link :to="{ pypath: localePath(`/warehouses/${warehouse.displayNumber}`), query: {...$route.query, area }}" class="text-secondary font-bold underline">
          {{ $t('warehouse.warehouse-at', { address })}}
        </nuxt-link>
      </h2>
      <div class="flex items-center">
        <span class="text-base">{{ address }}</span>
      </div>
        <div class="mt-1 text-xs flex">{{ locations }}</div>
      <div class="mt-3 flex">
        <div class="inline-flex justify-center items-center w-5 h-6 mr-4"><img src="~assets/img/warehouse/icon/calendar-clock.svg" alt=""></div>
        <ul class="tags">
          <li :class="{ nope: !weekdays }">{{$t('warehouse.weekdays')}}<span class="ml-2" v-if="weekdays">{{ weekdays }}</span></li>
          <li :class="{ nope: !saturdays }">{{$t('warehouse.saturdays')}}</li>
          <li :class="{ nope: !sundays }">{{$t('warehouse.sundays')}}</li>
          <li :class="{ nope: !holidays }">{{$t('warehouse.holidays')}}</li>
        </ul>
      </div>
     <div class="mt-3 flex">
        <div class="inline-flex justify-center items-center w-5 h-6 mr-4"><img src="~assets/img/warehouse/icon/truck.svg" alt=""></div>
        <ul class="tags">
          <li v-for="opt in deliveryTypes" :key="opt" :class="{ nope: !warehouse.deliveryTypes.includes(opt) }">{{$t(`warehouse.${opt}`)}}</li>
        </ul>
      </div>
      <div class="mt-3 flex">
        <div class="inline-flex justify-center items-center w-5 h-6 mr-4"><img src="~assets/img/warehouse/icon/temperature.svg" alt=""></div>
        <ul class="tags">
          <li v-for="opt in temperatureTypes" :key="opt" :class="{ nope: !warehouse.temperatureControl.includes(opt) }">{{$t(`warehouse.${opt}`)}}</li>
        </ul>
      </div>
      <div class="flex flex-col justify-center items-center md:justify-start mt-5">
        <nuxt-link
          class="detail-warehouse-link w-full"
          :to="{ path: localePath(`/warehouses/${warehouse.displayNumber}`), query: {...$route.query, area }}"
        >
          {{ $t('warehouse.see-details') }}
        </nuxt-link>
        <button class="heap-contact-warehouse-list contact-warehouse-link cursor-pointer h-12 mt-3 w-full" @click="openInquiry(warehouse)">
          {{ $t('warehouse.contact-warehouse') }}
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
.warehouse-photo
  @apply w-full
  aspect-ratio: 4 / 3
  object-fit: cover
  object-position: 50% 50%
  @screen md
    aspect-ratio: 80 / 54
  min-height: 170px
.tags
  @apply flex flex-wrap items-center
  > * + *
    margin-top: 0.25rem
  li
    @apply inline-flex items-center h-5 px-2 rounded text-sm bg-gray-200 mr-1
    &.nope
      @apply text-gray-400
.detail-warehouse-link
  @apply inline-flex h-10 justify-center items-center rounded-full text-center text-sm whitespace-no-wrap text-secondary border border-secondary px-3
  min-width: 14rem
.contact-warehouse-link
  @apply inline-flex h-10 justify-center items-center rounded-full text-center text-sm whitespace-no-wrap text-white bg-orange px-3
  min-width: 14rem
.contact-warehouse-link-icon
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%)
  height: 1.25rem
</style>

<script>
import { getFirstUrl } from '@/components/utils/warehouse';
import { deliveryTypes, temperatureTypes } from '@/model/warehouse';

export default {
  props: {
    warehouse: { type: Object, required: true },
    area: { type: String, default: '' }
  },
  data() {
    const dt = deliveryTypes.concat();
    const otherIndex = dt.indexOf('other');
    if (otherIndex >= 0) dt.splice(otherIndex, 1);
    return {
      deliveryTypes : dt,
      temperatureTypes
    }
  },
  computed: {
    address () {
      return `${this.warehouse.address.regionName}${this.warehouse.address.muniName}`;
    },
    locations () {
      return this.warehouse.relativeLocations
        .map((loc) => {
          return this.$t('warehouse.min-from-location', { locationName: loc.name, min: loc.distance_in_minutes });
        })
        .join(this.$t('warehouse.comma-space'));
    },
    weekdays () {
      return this.getOperatingTimesTag('weekdays', true);
    },
    saturdays () {
      return this.getOperatingTimesTag('saturdays');
    },
    sundays () {
      return this.getOperatingTimesTag('sundays');
    },
    holidays () {
      return this.getOperatingTimesTag('holidays');
    }
  },
  methods: {
    getFirstUrl,
    getOperatingTimesTag(period, showTime) {
      const opTime = this.warehouse.operatingTimes.find(ot => ot.period === period);
      return (showTime && opTime) ? `${opTime.startTime} - ${opTime.endTime}` : opTime;
    },
    openInquiry (warehouse) {
      this.$router.push({ path: this.localePath('/inquiry/'), query: { warehouse_code: warehouse.displayNumber } });
    }
  }
}
</script>